module.exports = __webpack_public_path__ + "img/yellow_style.33f82287.png";